// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".outer[data-v-57828706]{position:relative;text-align:center;margin:12px 0}.title[data-v-57828706]{font-size:1.3rem;font-weight:700;display:block;padding:24px 16px 4px;scroll-margin-top:120px}", ""]);
// Exports
module.exports = exports;
